/* eslint-disable import/no-named-as-default */
import App from 'containers/App';
import LoginPage from 'pages/LoginPage';
import HomePage from 'pages/HomePage';
import CallbackPage from 'pages/CallbackPage';
import WorkOrderDetailPage from 'pages/WorkOrderDetailPage';
import MyRoutePage from 'pages/MyRoutePage';
import SettingPage from 'pages/SettingPage';
import TechSearchPage from 'containers/pages/TechSearchPage';
import TechHistoryPage from 'containers/pages/TechHistoryPage';
import TransferEquipmentPage from 'containers/pages/TransferEquipmentPage';
import TechAdminPage from 'containers/pages/TechAdminPage';
import EquipmentSearchPage from 'containers/pages/EquipmentSearchPage';
import InventoryPage from 'pages/InventoryPage';
import CloseOrderPage from 'pages/CloseOrderPage';
import WorkOrderTransferPage from './containers/pages/WorkOrderTransferPage';

const routes = [
    {
        path: '/',
        component: App,
        allowAnonymous: true,
        routes: [
            {
                path: '/login',
                exact: true,
                component: LoginPage,
                allowAnonymous: true,
            },
            {
                path: '/callback',
                exact: true,
                component: CallbackPage,
                allowAnonymous: true,
            },
            {
                path: '/',
                exact: true,
                component: HomePage,
            }, {
                path: '/chat',
                exact: true,
                component: require('./containers/pages/ChatPage').default
            }, {
                path: '/my-route',
                exact: true,
                component: MyRoutePage
            }, {
                path: '/work-order-detail/:workOrderId',
                exact: true,
                component: WorkOrderDetailPage
            }, {
                path: '/work-order-close/:workOrderId',
                exact: true,
                component: CloseOrderPage
            }, {
                path: '/tech-search',
                exact: true,
                component: TechSearchPage
            }, {
                path: '/tech-history-search',
                exact: true,
                component: TechHistoryPage
            }, {
                path: '/equipment-transfer',
                exact: true,
                component: TransferEquipmentPage
            }, {
                path: '/work-order-transfer',
                exact: true,
                component: WorkOrderTransferPage
            }, {
                path: '/settings',
                exact: true,
                component: SettingPage
            }, {
                path: '/inventory',
                exact: true,
                component: InventoryPage
            }, {
                path: '/equipment-search',
                exact: true,
                component: EquipmentSearchPage
            }, {
                path: '/tech-admin-page',
                exact: true,
                component: TechAdminPage
            }
        ]
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js